// extracted by mini-css-extract-plugin
export default {"alert":"Alert_alert__rEteH"};